module.exports = __webpack_public_path__ + "static/summary_report-79ec018d4c259e2098f45ef2d65118a8.png";